export function scoreClass(score) {
  if (score >= 80) return "score-urgent";
  if (score >= 60) return "score-high";
  if (score >= 45) return "score-medium";
  return "score-low";
}

export function alertColor(level) {
  if (level === "high") return { bg: "#FEF2F2", text: "#B91C1C", border: "#FCA5A5" };
  if (level === "medium") return { bg: "#FFFBEB", text: "#B45309", border: "#FCD34D" };
  return { bg: "#F1F5F9", text: "#475569", border: "#CBD5E1" };
}

export function sentimentColor(sentiment) {
  switch (sentiment) {
    case "positive": return "#10B981";
    case "negative": return "#EF4444";
    case "mixed": return "#8B5CF6";
    default: return "#64748B";
  }
}

export function templateMeta(id) {
  switch (id) {
    case "news_monitoring":
      return { label: "News", color: "#0F1F3D", icon: "Newspaper" };
    case "tender_monitoring":
      return { label: "Tender", color: "#B45309", icon: "FileText" };
    case "regulatory_monitoring":
      return { label: "Regulatory", color: "#047857", icon: "Scale" };
    default:
      return { label: id, color: "#475569", icon: "Layers" };
  }
}

export function templatesMeta(ids) {
  const arr = Array.isArray(ids) ? ids : [ids];
  return arr.map((id) => templateMeta(id));
}

// ---------------------------------------------------------------------------
// Date / timezone helpers (Phase 2 #9 — store UTC, render in user's local tz)
//
// All ISO strings coming from the API are UTC. These helpers convert to the
// user's local timezone (auto-detected from the browser) at render time.
// ---------------------------------------------------------------------------

/** Returns the browser's resolved IANA timezone, e.g. "Asia/Kolkata". */
export function getUserTz() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      day: "numeric", month: "short", year: "numeric",
    });
  } catch { return iso; }
}

/** Full datetime in the user's local timezone, e.g. "16 Jun 2026, 2:15 PM IST". */
export function fmtDateTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString(undefined, {
      day: "numeric", month: "short", year: "numeric",
      hour: "numeric", minute: "2-digit",
      timeZoneName: "short",
    });
  } catch { return iso; }
}

/** Time only in the user's local timezone. */
export function fmtTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleTimeString(undefined, {
      hour: "numeric", minute: "2-digit",
    });
  } catch { return iso; }
}

/** True iff `iso` falls on the same calendar day as "now" in the user's local tz. */
export function isToday(iso) {
  if (!iso) return false;
  try {
    const d = new Date(iso);
    const now = new Date();
    return (
      d.getFullYear() === now.getFullYear() &&
      d.getMonth() === now.getMonth() &&
      d.getDate() === now.getDate()
    );
  } catch { return false; }
}

/** True iff `iso` falls on the previous calendar day (yesterday) in user's local tz. */
export function isYesterday(iso) {
  if (!iso) return false;
  try {
    const d = new Date(iso);
    const y = new Date();
    y.setDate(y.getDate() - 1);
    return (
      d.getFullYear() === y.getFullYear() &&
      d.getMonth() === y.getMonth() &&
      d.getDate() === y.getDate()
    );
  } catch { return false; }
}

export function fmtRelative(iso) {
  if (!iso) return "Never";
  const diff = Date.now() - new Date(iso).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return "Just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}
